// src/dom/get-document-size/get-document-size.ts
var getDocumentSize = (axis = "y") => {
  const scrollWidth = Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.body.clientWidth,
    document.documentElement.clientWidth
  );
  const scrollHeight = Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
  return axis === "both" ? { x: scrollWidth, y: scrollHeight } : axis === "x" ? scrollWidth : scrollHeight;
};

export {
  getDocumentSize
};
